'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../../common/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = _styles2.default.colors;
var _default = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-around',
		alignItems: 'center',
		background: colors.offWhite,
		width: '32%',
		height: '6.2em',
		padding: '0.5em 0',
		boxSizing: 'border-box'
	},
	title: {
		fontSize: '2.14em',
		color: colors.green,
		fontWeight: '300'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(colors, 'colors', 'src/components/WMStat/styles/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMStat/styles/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMStat/styles/index.js
// module id = n/VG
// module chunks = 62 63